module.exports = "<sn-usc-doc-nav view=\"{{view}}\"></sn-usc-doc-nav>\n<div class=\"usc-store dt\">\n    <br/>\n    <br/>\n    <sn-data-table [data_table_view]=\"view\" [adapter]=\"adapter\"></sn-data-table>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-uploaded-documents/usc-uploaded-documents.component.html
// module id = ../../../../../src/app/components/usc-store/usc-uploaded-documents/usc-uploaded-documents.component.html
// module chunks = main